import { serialAND, serialOR } from './util/';

//Globally available Adapters. addRestriction populates this.
const restrictions  = {
	default: () => false
};

/**
 * Add a new restriction to the global restriction system.
 * @param {String} restriction a name or regex for the restirction you want to add.
 * @param {Function} impl An adapter function: (restriction, props, context) => {}.
 */
export function addRestriction(restriction, adapter) {
	if (!restriction || !adapter) return false;
	restrictions[restriction] = adapter;
	return true;
}

/**
 * Forcefully removes a restriction from the global restriction system.
 * @param {String} restriction a name or regex of the restirction you want to remove.
 */
export function removeRestriction(restriction) {
	if (!restriction || !restrictions[restriction]) return false;
	delete restrictions[restriction];
	return true;
}

/**
 * Resolve a restriction adapter by restriction name.
 * @param {String} restriction The name of the restriction. Either an explicit name or a string that matches a regex.
 * @param [Object] props The props object that this restriction is being resolved for.
 * @param [Object] context The context object that this restriction is being resolved for.
 * @returns A boolean or a Promise that resolves to a boolean.
 */
export default function isAllowed(restriction = 'default', props, context) {
	// AND - []:
	if (Array.isArray(restriction)) {
		return serialAND(restriction, r => isAllowed(r, props, context));
	}

	// OR - {or:[]}
	if (restriction.or) {
		return serialOR(restriction.or, r => isAllowed(r, props, context));
	}

	// Individual Restriction
	let matches = Object.keys(restrictions).filter(key => restriction.match(key));
	let restrictionMatch = matches.length > 0 && restrictions[matches[0]] || restrictions.default;
	return restrictionMatch(restriction, props, context);
}

/**
 * This Component can be used to optioanlly render children based on the result of
 * a supplied restriction condition.
 */
import Restriction from './components/restriction/';
export { Restriction };

/*
Add built-in Restriction Adapters:
*/

import device, { NAME as NAME_DEVICE } from './adapters/device';
addRestriction(NAME_DEVICE, device);

import delay, { NAME as NAME_DELAY } from './adapters/delay';
addRestriction(NAME_DELAY, delay);

import debug, { NAME as NAME_DEBUG } from './adapters/debug';
addRestriction(NAME_DEBUG, debug);

import cube, { NAME as NAME_CUBE } from './adapters/cube';
addRestriction(NAME_CUBE, cube);
